import { themeObj } from 'styling/theme'
import wordFlowImg from 'assets/poll-icon.svg'

const emojiSize = '25px'
const chatElementsHeight = 40
const chatInputContainerPadding = 15

export const button = {
    cursor: 'pointer',
    height: chatElementsHeight,
    width: '40px',
    fontSize: emojiSize,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#252d3d !important',
    borderColor: '#252d3d !important',
}

export const styles = () => ({
    '@keyframes fadeWordFlowBtn': {
        from: {
            transform: 'translateY(50px)',
            opacity: 0,
        },
        to: {
            transform: 'translateY(0)',
            opacity: 1,
        },
    },

    chatbox: {
        padding: 0,
    },
    fullScreen: {},
    chatInputContainer: {
        display: 'flex',
        padding: chatInputContainerPadding,
        background: '#151a24',
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: '100%',
        zIndex: 2,

        '&$fullScreen': {
            padding: 0,
        },
    },
    chatForm: {
        width: '100%',
        display: 'flex',
        overflow: 'scroll',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
    },
    chatInput: {
        minWidth: '55%',
        border: 'none',
        borderRadius: '3px;',
        paddingLeft: '10px',
        backgroundColor: '#2E3747',
        height: chatElementsHeight,
        '&:focus': {
            backgroundColor: '#2E3747',
            outline: 'none',
        },
    },

    tvChatInput: {
        minWidth: '83%',
        border: 'none',
        borderRadius: '3px;',
        paddingLeft: '10px',
        backgroundColor: '#2E3747',
        height: chatElementsHeight,
        '&:focus': {
            backgroundColor: '#2E3747',
            outline: 'none',
        },
    },

    luaButtons: {
        display: 'flex',
    },
    chatSendButton: {
        ...button,
        transform: 'translateX(-3px)',
        fontSize: '15px',
        border: 0,
    },
    wordFlowBtnWrapper: {
        position: 'absolute',
        bottom: 80,
        left: 0,
        width: '100%',
        textAlign: 'center',
        zIndex: themeObj.zIndexLevels.one,
        animation: '$fadeWordFlowBtn .2s linear',
    },

    wordFlowBtn: {
        color: themeObj.colors.white,
        fontFamily: themeObj.typographyPresets.fonts.notoSans.regular,
        fontSize: 13,
        lineHeight: 1.38,
        borderRadius: 6,
        border: 0,
        backgroundColor: themeObj.colors.brand.blue,
        padding: '15px 16px',

        '&:before': {
            content: "''",
            backgroundImage: `url(${wordFlowImg})`,
            backgroundRepeat: 'no-repeat',
            width: 24,
            height: 24,
            display: 'inline-block',
            verticalAlign: 'middle',
            marginRight: 16,
        },
    },

    '@media (max-width: 767px)': {
        chatbox: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            WebkitOverflowScrolling: 'touch',
            position: 'relative',
        },
        chatInputContainer: {
            position: 'fixed',
            bottom: 0,
            width: '100%',
        },
        chatInput: {
            minWidth: '70%',
        },
    },

    '@media (min-width: 768px) and (max-width: 1023px)': {
        wordFlowBtn: {
            padding: '19px 12px',
            fontSize: 12,

            '&:before': {
                marginRight: 10,
            },
        },
    },

    '@media (min-width: 768px)': {
        chatbox: {
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
        },
        chatSendButton: {
            display: 'none',
        },
    },
})
